<template>
  <div class="carrot">

    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">찾아가는 큐레이션 관리</h3>
              <p class="lead">
                - 찾아가는 큐레이션 컨텐츠 관리 페이지 입니다.<br>
              </p>
            </div>
          </div>
          <div class="row">

            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <div class="form-group float-left clear w-100per">
                      <button type="submit" class="btn btn-primary fr ml-10"
                              @click="moveCurations()">등록
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th style="width: 10%">No</th>
                        <th style="width: 30%">제목</th>
                        <th style="width: 50%">산업군</th>
                        <th>등록일</th>
                      </tr>
                      <tr v-for="item in curations" :key="item.idx">
                        <td>{{ item.idx }}</td>
                        <td><a style="color:dodgerblue; cursor: pointer" @click="moveCuration(item.idx)">{{ item.title }}</a></td>
                        <td><span class="ml-1 label-industry" v-for="industry in item.industries" :key="industry.value">{{ industry }}</span></td>
                        <td>{{ item.createDate }}</td>
                      </tr>
                    </table>

                    <!-- <carrot-pagination v-model="search.page" :page="search.page" :total="total" :pagesize="50" @change="onPage" ></carrot-pagination> -->
                    <div style="padding-left:35%; padding-top:20px;">
                      <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                                :click-handler="clickCallback" :prev-text="'Prev'"
                                :next-text="'Next'" :container-class="'pagination'"
                                :page-class="'page-link'">
                      </paginate>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../components/inc_menu.vue'
import Paginate from 'vuejs-paginate';

export default {
  name: 'program',
  components: {
    Menu,
    Paginate,

  },
  props: {
    msg: String
  },
  data: () => ({
    filter: {
      page: 1
    },
    curations: [],
    lastpage: 1

  }),
  mounted() {
    this.initPage();
  },
  methods: {
    clickCallback: function (pageNum) {
      this.filter.page = pageNum;
      this.initPage();
    },
    initPage: function () {
      this.getCurations(this.filter.page)
    },

    getCurations: function (page) {
      const url = this.$store.state.host + "/v1/admin/curations";
      var params = {
        page: page
      }

      this.axios.get(url, {
        params
      })
      .then((res) => {
        this.curations = res.data.result.value;
        this.lastpage = res.data.result.lastPage;

      });
    },

    moveCuration: function (idx) {
      const url = 'http://admin.imooc.co.kr/rest/auth/login?kname=' + localStorage.getItem('kname') + '&email=' + localStorage.getItem('uid');
      var wnd = window.open(url);
      setTimeout(function() {
        wnd.location.href = 'https://admin.imooc.co.kr/admin/curation/view/' + idx
      }, 500);
    },

    moveCurations: function () {
      location.href = 'http://admin.imooc.co.kr/rest/auth/login?kname=' + localStorage.getItem('kname') + '&email=' + localStorage.getItem('uid');
    }


  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

</style>
